import { useAddCaseFormContext } from '../contexts/AddCaseFormContext';

const useLiabilityAnalysisForm = () => {
  const { formik, updateCase, updateLiabilityFilesDefendants } = useAddCaseFormContext();

  const defendants = formik.values.defendants || [];

  const setIsSingleLiabilitySection = (value, defendantArr = defendants, liabilityOverride) => {
    const data = {};
    formik.setFieldValue('caseInfo.isSingleLiabilitySectionForAllDefendants', value);
    data['caseInfo.isSingleLiabilitySectionForAllDefendants'] = value;
    updateCase({ data });
    if (value) {
      updateLiabilityFilesDefendants(defendantArr, liabilityOverride);
    }
  };

  const toggleSingleLiabilityMode = (e) => {
    const isChecked = e.target.checked;
    setIsSingleLiabilitySection(isChecked)
  };

  return {
    defendants,
    setIsSingleLiabilitySection,
    toggleSingleLiabilityMode,
    isSingleLiabilityMode: formik.values.caseInfo?.isSingleLiabilitySectionForAllDefendants || false
  };
};

export default useLiabilityAnalysisForm;
